import { render, staticRenderFns } from "./WidgetTokenList.vue?vue&type=template&id=3f12bc78&"
import script from "./WidgetTokenList.vue?vue&type=script&lang=js&"
export * from "./WidgetTokenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetTokenList.vue"
export default component.exports